import React from 'react';
import moment from 'moment';
import './ParkingInfo.css';

import { FaAngleDoubleRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const ParkingInfo = (props) => {

    // 解構 props
    const { parkingRecords, emptyMessage } = props;

    // 顯示空白資訊的函數
    const emptyObject = (message) => {
        return (
            <div className='messageBox'>
                <div className='box'>
                    {/* 空白的停車資訊 */}
                    <div className='emptyParkingInfo'>{message}</div>
                </div>
            </div>
        );
    };

    if (!parkingRecords || parkingRecords.length === 0) {
        // 回傳空白資訊
        return emptyObject(emptyMessage);
    } else {
        // 回傳停車的資訊
        return (
            <div className='parkingInfoArea'>
                {parkingRecords.map((item, index) => {
                    return (
                        <div className='single-parking-info' key={item.plate + "_" + index}>
                            {index >= 1 && <h4>第{index + 1}筆</h4>}

                            <div className='info-box'>
                                <div className="parking-date">
                                    {moment(item.enterTime).format('YYYY-MM-DD HH:mm:ss')}
                                </div>
                                <div className="lot-name">{item.lotName}</div>
                                <div className="plateNo">{item.plateNo}</div>
                                <div className="split"> </div>
                                {item.categoryList && item.categoryList.map((category, catIndex) => (
                                    <React.Fragment key={`${item.plate}-category-${catIndex}`}>
                                        <div className="category-label">{category.label}</div>
                                        <div className="category-value">
                                            {category.value === -1 ? '----' : `${category.value}`}
                                        </div>
                                    </React.Fragment>
                                ))}
                                <div className="split"> </div>
                                <div className="parking-remain-label">待繳</div>
                                <div className="parking-remain">
                                    {item.remain === -1 ? '----' : `NTD.${item.remain}`}
                                </div>
                            </div>

                            {
                                item.discountsList.length > 0 && item.discountsList && item.discountsList.map((record, discIndex) => (

                                    <React.Fragment key={`${item.plate}-discount-${discIndex}`}>
                                        <div className="discount-record">

                                            <div className="discount-label">{record.label}</div>
                                            <div className="discount-value">{record.value}</div>
                                        </div>

                                    </React.Fragment>
                                ))
                            }


                        </div>
                    )
                })}
            </div>
        );
    }
}

export default ParkingInfo;